import { MyTasksTypes } from './types';

const { TOGGLE_MY_TASK } = MyTasksTypes;

interface UpcomingState {
  toggleMyTask: any;
}

export const initialState: UpcomingState = {
  toggleMyTask: null,
};

// eslint-disable-next-line default-param-last
const studyReducer = (state = initialState, action: any): UpcomingState => {
  switch (action.type) {
    case TOGGLE_MY_TASK: {
      return {
        ...state,
        toggleMyTask: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default studyReducer;
